import { render, staticRenderFns } from "./StoreView.vue?vue&type=template&id=b89e508e&scoped=true"
import script from "./StoreView.vue?vue&type=script&lang=js"
export * from "./StoreView.vue?vue&type=script&lang=js"
import style0 from "./StoreView.vue?vue&type=style&index=0&id=b89e508e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89e508e",
  null
  
)

export default component.exports